import { PartialNullable } from "../../Extensions";
import { Property } from "../../RadObject";
import { WebApiClientService } from "../../Server/WebApiClientService";
import { ServiceManager } from "../../ServiceManager";
import { CheckBoxListPermission, CheckBoxListPermissionPropertyValues, ICheckBoxListPermission } from "./CheckBoxListPermission";
import { NAMESPACE } from "./_Namespace";

export type CheckBoxListPermissionEntityPropertyValues =
    CheckBoxListPermissionPropertyValues
    & {
    };

export type CheckBoxListPermissionEntityProperties = {
    [name in keyof CheckBoxListPermissionEntityPropertyValues]: Property<CheckBoxListPermissionEntityPropertyValues[name]>
};

export interface ICheckBoxListPermissionEntity extends ICheckBoxListPermission, CheckBoxListPermissionEntityProperties
{
}

export class CheckBoxListPermissionEntity extends CheckBoxListPermission implements ICheckBoxListPermissionEntity
{
    // #region Static

    public static override classNamespace = NAMESPACE + "CheckBoxListPermissionEntity";
    public static override className = "CheckBoxListPermissionEntity";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<CheckBoxListPermissionEntityPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                createEditorControl: () => new CheckBoxListPermission(),
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Public Methods

    public async loadDataAsync()
    {
        const
            data =
                await ServiceManager.getRequired(WebApiClientService)
                    .createApiMethodRequest("DataService", "CallDataService", { id: "2de87e78-0a5e-4b11-81ba-1d7fb096c440" })
                    .executeAsync();

        this.listDataSource.set(data.map((item: any) => ({ value: item.value, description: item.description })));
    }

    // #endregion

    // #endregion
}
